import { type BlogPost } from "./types";

export const miSupportKalender: BlogPost = {
  id: "mi-support-kalender",
  slug: { da: "mi-support-kalender", en: "mi-support-calendar", de: "mi-support-kalender" },
  datePublished: "2021-12-08",
  dateModified: "2025-06-26",
  author: "Jonas Christensen",
  heroImage: "/__l5e/assets-v1/296eb1c2-deca-40a7-8df6-eb1820d5375d/MI_Support_Kalender_2027_Page_1.png",
  tags: ["MI Support", "Kalender"],
  content: {
    da: {
      title: "MI Support kalender",
      description:
        "MI Supports kalender for 2027 er klar. Du kan hente den som PDF og selv printe den eller få den tilsendt med posten.",
      heroAlt: "Forsiden af MI Supports byggekalender",
      body: [
        { type: "paragraph", text: "MI Supports kalender for 2027 er klar. Du kan hente den som PDF og selv printe den – eller få den tilsendt med posten." },
        { type: "heading", text: "MI Supports kalender for 2027 er klar" },
        { type: "paragraph", text: "Kalenderen er lavet i et printvenligt PDF-format, så du nemt kan hænge den op på kontoret eller på byggepladsen. Den giver et godt overblik over årets uger og helligdage." },
        { type: "download", href: "/wp-content/uploads/MI-Support-Kalender-2027.pdf", label: "Hent kalenderen som PDF" },
        { type: "heading", text: "Få kalenderen tilsendt i fysisk format" },
        { type: "paragraph", text: "Har I brug for en fysisk kopi af kalenderen, sender vi den gerne med posten. Kontakt os med jeres navn og adresse, så sørger vi for resten." },
      ],
      faq: [
        { q: "Hvordan henter jeg MI Support-kalenderen?", a: "Kalenderen kan hentes som en printvenlig PDF direkte her på siden via download-knappen. Kontakt os, hvis du ønsker en fysisk kopi." },
        { q: "Kan jeg få kalenderen tilsendt fysisk?", a: "Ja. Skriv til os med navn og adresse, så sender vi en trykt kalender med posten." },
        { q: "Hvad koster kalenderen?", a: "Kalenderen er gratis – både som PDF og i fysisk format." },
      ],
    },
    en: {
      title: "MI Support calendar",
      description:
        "MI Support's calendar for 2027 is ready. Download it as a PDF and print it yourself, or have it sent to you by post.",
      heroAlt: "The cover of MI Support's construction calendar",
      body: [
        { type: "paragraph", text: "MI Support's calendar for 2027 is ready. You can download it as a PDF and print it yourself – or have it sent to you by post." },
        { type: "heading", text: "MI Support's calendar for 2027 is ready" },
        { type: "paragraph", text: "The calendar is made in a print-friendly PDF format, so you can easily put it up at the office or on the construction site. It gives a clear overview of the year's weeks and public holidays." },
        { type: "download", href: "/wp-content/uploads/MI-Support-Kalender-2027.pdf", label: "Download the calendar as PDF" },
        { type: "heading", text: "Get the calendar sent in physical format" },
        { type: "paragraph", text: "If you need a physical copy of the calendar, we're happy to send it by post. Contact us with your name and address, and we'll take care of the rest." },
      ],
      faq: [
        { q: "How do I get the MI Support calendar?", a: "The calendar is available as a print-friendly PDF directly on this page via the download button. Contact us if you would like a physical copy." },
        { q: "Can I have the calendar sent physically?", a: "Yes. Write to us with your name and address, and we'll send a printed calendar by post." },
        { q: "How much does the calendar cost?", a: "The calendar is free – both as a PDF and in physical format." },
      ],
    },
    de: {
      title: "Der MI Support Kalender",
      description:
        "Der MI Support Kalender für 2027 ist da. Laden Sie ihn als PDF herunter und drucken Sie ihn selbst oder lassen Sie ihn sich per Post zusenden.",
      heroAlt: "Das Titelblatt des Baukalenders von MI Support",
      body: [
        { type: "paragraph", text: "Der MI Support Kalender für 2027 ist da. Sie können ihn als PDF herunterladen und selbst ausdrucken – oder ihn sich per Post zusenden lassen." },
        { type: "heading", text: "Der MI Support Kalender für 2027 ist da" },
        { type: "paragraph", text: "Der Kalender ist in einem druckfreundlichen PDF-Format erstellt, sodass Sie ihn leicht im Büro oder auf der Baustelle aufhängen können. Er bietet einen guten Überblick über die Wochen und Feiertage des Jahres." },
        { type: "download", href: "/wp-content/uploads/MI-Support-Kalender-2027.pdf", label: "Kalender als PDF herunterladen" },
        { type: "heading", text: "Den Kalender in physischer Form erhalten" },
        { type: "paragraph", text: "Wenn Sie ein physisches Exemplar des Kalenders benötigen, senden wir es Ihnen gern per Post. Kontaktieren Sie uns mit Ihrem Namen und Ihrer Adresse, und wir kümmern uns um den Rest." },
      ],
      faq: [
        { q: "Wie erhalte ich den MI Support Kalender?", a: "Der Kalender ist als druckfreundliche PDF direkt auf dieser Seite über den Download-Button verfügbar. Kontaktieren Sie uns, wenn Sie ein physisches Exemplar wünschen." },
        { q: "Kann ich den Kalender physisch zugesendet bekommen?", a: "Ja. Schreiben Sie uns mit Ihrem Namen und Ihrer Adresse, und wir senden Ihnen einen gedruckten Kalender per Post." },
        { q: "Was kostet der Kalender?", a: "Der Kalender ist kostenlos – sowohl als PDF als auch in physischer Form." },
      ],
    },
  },
};
